import { Link, PulseLogo, Text } from '@pulsex/uikit'
import { ChainId } from '@pulsex/chains'
import { getBlockExplorerLink } from 'utils'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useTranslation } from '@pulsex/localization'
import truncateHash from 'utils/truncateHash'

interface DescriptionWithTxProps {
  description?: string
  txHash?: string
  txChainId?: number
}

const DescriptionWithTx: React.FC<React.PropsWithChildren<DescriptionWithTxProps>> = ({
  txHash,
  txChainId,
  children,
}) => {
  const { chainId } = useActiveWeb3React()
  const { t } = useTranslation()

  return (
    <>
      {typeof children === 'string' ? <Text as="p">{children}</Text> : children}
      {txHash && (
        <Link external href={getBlockExplorerLink(txHash, 'transaction', chainId)}>
          {t('View on PulseScan')}: {truncateHash(txHash, 8, 0)}
          {(txChainId || chainId) === ChainId.PULSECHAIN && <PulseLogo color="primary" ml="4px" />}
        </Link>
      )}
    </>
  )
}

export default DescriptionWithTx
